import { Component } from "react";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import * as ImgUtils from "@discovery/components-luna/lib/utils/image";
import * as styles from "./styles.css";
import { PlaceholderImage } from "../../../atoms/placeholder-image";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
export var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType[ThumbnailType["BASIC"] = 0] = "BASIC";
    ThumbnailType[ThumbnailType["CONTINUE_WATCHING"] = 1] = "CONTINUE_WATCHING";
    ThumbnailType[ThumbnailType["SHORTS"] = 2] = "SHORTS";
})(ThumbnailType || (ThumbnailType = {}));
export class ThumbnailImage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            imageLoaded: false,
        };
        this.imageLoaded = () => {
            setTimeout(() => {
                this.setState({
                    imageLoaded: true,
                });
            }, 300);
        };
    }
    render() {
        const { thumbnail = ThumbnailType.BASIC, srcM = M.empty(), classNameM = M.empty(), image, } = this.props;
        return (React.createElement("div", { className: cn(thumbnail === ThumbnailType.BASIC
                ? cn([styles.bannerContainer, styles.bannerContainerShow])
                : styles.bannerContainer) },
            React.createElement(PlaceholderImage, null),
            image ? (React.createElement(SonicImage, { image: image, imageSizes: {
                    default: [100, "vw"],
                    maxWidthMediaQueries: [
                        [699, "px", 320, "px"],
                        [1023, "px", 440, "px"],
                        [1439, "px", 600, "px"],
                        [2559, "px", 800, "px"],
                    ],
                }, extraImageWidths: [320, 480, 700, 1024], className: cn(styles.bannerImage, classNameM), fallbackImageSize: { width: 700 }, alt: "" })) : (React.createElement(RenderMaybe, null, M.map((src) => (React.createElement(React.Fragment, null, src && (React.createElement("img", { alt: "Dplus", src: ImgUtils.resizeH(400, ImgUtils.jpeg(src)), className: cn(styles.bannerImage, classNameM), srcSet: ImgUtils.srcSet([320, 480, 700, 1024], ImgUtils.jpeg(src)), onLoad: this.imageLoaded })))), srcM))),
            thumbnail === ThumbnailType.SHORTS && (React.createElement("div", { className: styles.bannerGradientShorts }))));
    }
}

